export default {
	lia: {
		viewingAsAccount:
			'Your data is currently being displayed from the perspective of the account of <b class="text-white">{name}</b>',
	},
}
